import { defineStore } from 'pinia'
import { computed, reactive, ref } from 'vue'

/**
 * @title 用于保存&更新按钮配置存储状态
 * @auth yzs
 */
export const useButtonUpdateStore = defineStore('buttonUpdate', {
    state: () => ({
        tabCurrent: '',
        type: '',
        dialogShow: false,
        networkDialogShow: false,
        deleteDialogShow: false,
        staticBackFillShow: false,
        staticDeleteShow: false,
        dialogRedirect: false,
        tableList: [{
            title: '校验配置',
            component: 'Verify',
            event: 'verifyConfig',
        },
        {
            title: '保存配置',
            component: 'Save',
            event: 'saveConfig',
        },
        {
            title: '消息配置',
            component: 'Message',
            event: 'messageConfig',
        },
        {
            title: '回填配置',
            component: 'BackFill',
            event: 'backFillConfig',
        },
        {
            title: '跳转设置',
            component: 'Jump',
            event: 'jumpConfig',
        }],
        deleteList: [{
            title: '校验配置',
            component: 'Verify',
            event: 'verifyConfig',
        },
        {
            title: '删除配置',
            component: 'Delete',
            event: 'deleteConfig',
        },
        {
            title: '消息配置',
            component: 'Message',
            event: 'messageConfig',
        },
        {
            title: '跳转设置',
            component: 'Jump',
            event: 'jumpConfig',
        }],
        backFillList: [{
            title: '回填配置',
            component: 'BackFill',
            event: 'backFillConfig',
        }],
        staticDelList: [{
            title: '消息配置',
            component: 'Message',
            event: 'messageConfig',
        }],
        networkRequest: [{
            title: '参数配置',
            component: 'Verify',
            event: 'verifyConfig',
        },
        {
            title: '消息配置',
            component: 'Message',
            event: 'messageConfig',
        },
        {
            title: '回填配置',
            component: 'BackFillData',
            event: 'backFillDataConfig',
        },
        {
            title: '跳转设置',
            component: 'Jump',
            event: 'jumpConfig',
        }],
        selectComponent: {
            target: {
                field: '',
                index: 0
            },
            id: null,
            title: '',
            status: 'set',
            isSelect: false  // 勾选控件
        },
        selectMoreComponent: {
            status: 'set',
            isSelect: false, // 多选控件
            type: 'to',
            target: [],
            to: []
        },
        multSelectComponent:{
            isSelect: false, // 多选控件
            tempTarget: {},  // 临时选中对象集合
            target: {}  // 最终选中对象集合
        },
        verifyConfig: {
            paramData: [],
            apiType: '',
            apiId: '',
            apiUrl: '',
            detail: {
                name: '',
                description: '',
                parameter: '',
            },
        },
        saveConfig: {
            table: [{
                dataSrouceId: null, // 数据源id
                tableName: null, // 表名
                primaryKey: null, // 表字段
                primaryKeyType: '', // 主键值类型
                primaryKeyValue: '', // 主键值
                paramsList: [ // 字段配置
                    // {
                    //     paramsType: null, // 类型
                    //     paramsName: null, // 名称
                    //     paramsValue: null // 值
                    // }
                ]
            }],
            mainTableKeyOption: [],
            mainTableInfo: {}
        },
        jumpConfig: {
            toUrl: '',
            routerType: '',
            paramData: []
        },
        messageConfig: {
            successMessage: '',
            errorMessage: '',
            isMessage: false,
            messageType: 'tip',
        },
        backFillConfig: {
            paramData: []
        },
        backFillDataConfig: {
            paramData: []
        },

        deleteConfig: {
            table: [{
                dataSrouceId: null, // 数据源id
                tableName: null, // 表名
                primaryKey: null, // 表字段
                primaryKeyType: '', // 主键值类型
                primaryKeyValue: '', // 主键值
            }],
            mainTableKeyOption: []
            
        }

    }),
    actions: {
        // 初始化
        resetState() {
            this.$reset()
            console.log(this, "?1155")
        },
        setTabCurrent(value) {
            console.log(value, ';setTabCurrnet')
            this.tabCurrent = value
        },
        // 设置跳转控制器
        setDialogRedirect(flag) {
            this.dialogRedirect = flag
        },
        setType(type) {
            this.type = type
        },
        // 设置配置控制器
        setDialogShow(flag) {
            console.log(flag, this.type, '???')
            if (!flag) {
                this.dialogShow = false
                this.deleteDialogShow = false
                this.networkDialogShow = false
                this.staticBackFillShow = false
                this.staticDeleteShow = false
            } else {
                switch (this.type) {
                    case 'delete':
                        this.deleteDialogShow = true
                        break;
                    case 'update':
                        this.dialogShow = true
                        break;
                    case 'network':
                        this.networkDialogShow = true
                        break;
                    case 'staticBackFill':
                        this.staticBackFillShow = true
                        break;
                    case 'staticDelete':
                        this.staticDeleteShow = true
                        break;
                    default:
                        break;
                }
            }
        },
        resetMultSelectComp(id){
            console.log('重置multSelectComponent');
            this.multSelectComponent.tempTarget[id] = {}
            this.multSelectComponent.target[id] = {}
        },
        setMultSelectComp(){

        },
        // 设置控件选择开启/关闭
        setIsSelectComponent(flag) {
            this.selectComponent.isSelect = flag
        },
        // 设置控件选择值
        setSelectComponentControl({ id, title }) {
            this.selectComponent.id = id
            this.selectComponent.title = title

        },
        // 设置控件返回值
        setSelectComponentTarget(field, index) {
            this.selectComponent.target.field = field
            this.selectComponent.target.index = index
        },
        // 单选更新状态
        setSelectComponentStatus(status) {
            this.selectComponent.status = status
        },
        // 设置多选控件选择开启/关闭
        setIsMoreSelectComponent(flag) {
            this.selectMoreComponent.isSelect = flag
        },
        // 添加多选数组控件值
        setMoreSelectComponentAdd(paramData) {
            this.selectMoreComponent.target.push(paramData)
        },
        // 删除多选数组控件值
        setMoreSelectComponentRemove(index) {
            this.selectMoreComponent.target.splice(index, 1)
        },
        // 清空多选数据
        setMoreSelectComponentClear() {
            this.selectMoreComponent.to = []
            this.selectMoreComponent.target = []
        },
        // 多选更新状态
        setMoreSelectComponentStatus(status) {
            this.selectMoreComponent.status = status
        },

        // 设置网络请求api数据 - 接口类型
        setVerifyApiType(type) {
            this.verifyConfig.apiType = type
        },
        // 设置网络请求api数据 - 接口id
        setVerifyApiId(id) {
            this.verifyConfig.apiId = id
            if (id) {
                this.verifyConfig.apiUrl = 'https://60.205.187.97:19999/api/blade-logic/logic/run/' + id
            } else {
                this.verifyConfig.apiUrl = ''
            }
        },
        // 设置接口详情
        setVerifyDetail(data) {
            this.verifyConfig.detail = data
        },
        // 设置参数字段
        setVerifyParamData(paramData) {
            this.verifyConfig.paramData = paramData
        },
        // 设置校验配置数据
        setVerifyConfig(value) {
            this.verifyConfig = value
        },
        // 设置保存配置数据
        setSaveConfigTable(value) {
            this.saveConfig.table = value
        },
        // 设置执行完成后存储主表信息
        setSaveConfigMainTableInfo(mainTable) {
            this.saveConfig.mainTableInfo = mainTable
        },

        // 设置跳转配置数据
        setJumpConfig(value) {
            this.jumpConfig = value
        },

        // 设置回填配置数据
        setBackFillConfig(value) {
            this.backFillConfig = value
        },
        // 设置DATA回填配置数据
        setBackFillDataConfig(value) {
            this.backFillDataConfig = value
        },
        setBackFillDataParamData(list) {
            this.backFillDataConfig.paramData = list
        },
        setMessageConfig(value) {
            this.messageConfig = value
        },

        setDeleteConfig(value) {
            this.deleteConfig.table = value
        },
        // 主表主键设置
        setMainTableKeyOption(option, type) {
            switch (type) {
                case 'update':
                    this.saveConfig.mainTableKeyOption = option
                    break;
                case 'delete':
                    this.deleteConfig.mainTableKeyOption = option
                    break;
                default:
                    break;
            }
        }
    }
})